import { pdf_document, pdf_text_stream } from './company_reports_pdf_core';
import { pdf_report_lines } from './company_reports_pdf_lines';

export function rows_to_pdf(report = {}, rows = [], options = {}) {
  const lines = pdf_report_lines(report, rows, options);
  const stream = pdf_text_stream(lines);
  const objects = [
    '<< /Type /Catalog /Pages 2 0 R >>',
    '<< /Type /Pages /Kids [3 0 R] /Count 1 >>',
    '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 612 792] /Resources << /Font << /F1 4 0 R >> >> /Contents 5 0 R >>',
    '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica >>',
    `<< /Length ${stream.length} >>\nstream\n${stream}\nendstream`,
  ];
  return pdf_document(objects);
}
